import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VModal from "vue-js-modal";
import VueApexCharts from "vue-apexcharts";
import Gauge from "@chrisheanan/vue-gauge";
import DateRangePicker from "vue-mj-daterangepicker";
import "vue-mj-daterangepicker/dist/vue-mj-daterangepicker.css";

Vue.config.productionTip = false;
Vue.use(VModal, { dialog: true });
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);
Vue.use(Gauge);
Vue.component("gauge", Gauge.default);
Vue.use(DateRangePicker);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
